import {
  isSupportedCountry,
  parsePhoneNumberFromString
} from "libphonenumber-js/max";

export function phoneCountry(address) {
  const code = address && address.country && address.country.code;
  return typeof code === "string" && isSupportedCountry(code.toUpperCase())
    ? code.toUpperCase()
    : undefined;
}

export function shipmentPhoneCountry(endpoint) {
  if (!endpoint) return undefined;
  // An address left over from door delivery is not the selected office's country.
  return phoneCountry(
    endpoint.direct === false
      ? endpoint.office && endpoint.office.address
      : endpoint.address
  );
}

export function validatePhone(value, defaultCountry = "BG") {
  if (typeof value !== "string" || !value.trim()) return false;
  const country =
    typeof defaultCountry === "string" && isSupportedCountry(defaultCountry)
      ? defaultCountry
      : undefined;
  const phone = parsePhoneNumberFromString(value.trim(), {
    defaultCountry: country,
    extract: false
  });
  return !!phone && !phone.ext && phone.isValid();
}

export function phoneRules(
  translate,
  { country = null, required = false } = {}
) {
  return [
    value => {
      if (value == null || (typeof value === "string" && !value.trim())) {
        return !required || translate("Phone number is required");
      }
      if (
        !country &&
        typeof value === "string" &&
        !value.trim().startsWith("+")
      ) {
        return translate("Enter phone with international code");
      }
      return validatePhone(value, country) || translate("Invalid phone number");
    }
  ];
}
